import React from "react";
import { IConversation } from "../../storeroom/conversations/models";

export const ConversationContext = React.createContext<IConversation>(null);
